module.exports = {"431026102":"热水镇","431026103":"土桥镇","431026104":"泉水镇","431026105":"暖水镇","431026106":"大坪镇","431026107":"三江口瑶族镇","431026108":"卢阳镇","431026109":"马桥镇","431026110":"井坡镇","431026207":"南洞乡","431026209":"濠头乡","431026214":"延寿瑶族乡","431026216":"集益乡","431026217":"文明瑶族乡","431026400":"大坪国有林场","431026401":"汝城经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/431026.json
// module id = 1899
// module chunks = 0